import { Redirect } from "react-router-dom";

const HomePage = () => {
  return <Redirect to={{ pathname: "/dashboard" }} />;
};

export { HomePage };
